<template>
    <div class="info">
        <vue-topprogress color="#f7b400" ref="topProgress"></vue-topprogress>
        <div class="info-container">
            <div class="avatar">
                <img :src="'https://visage.surgeplay.com/full/284/'+punishment.uuid"/>
            </div>
            <div class="table">
                <table>
                    <thead>
                    <tr>
                        <th colspan="2">
                            {{title}} Information
                            <span class="options">
                                <a href="#" @click="showEditModal = true"
                                   v-if="type !== 'name' && (hasPermission(['bansite.edit.*', 'bansite.edit.all']) || (ownUuid === punishment.banned_by_uuid && hasPermission(['bansite.edit.own'])))">
                                    <font-awesome-icon icon="edit"/>
                                </a>
                                <a href="#" @click="showDeleteModal = true"
                                   v-if="hasPermission(['bansite.unban.*', 'bansite.unban.all', 'bansite.unban.fvforum']) || (ownUuid === punishment.banned_by_uuid && hasPermission(['bansite.unban.own']))">
                                    <font-awesome-icon icon="trash-alt"/>
                                </a>
                            </span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Brugernavn</td>
                        <td>
                            <div class="user-float">
                                <router-link :to="getGoToUser(punishment.name, 'user')">
                                    <img :src="'https://visage.surgeplay.com/face/25/'+punishment.uuid"/>
                                    <span>{{punishment.name}}</span>
                                </router-link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{{titled}} af</td>
                        <td>
                            <div class="user-float">
                                <router-link :to="getGoToUser(punishment.banned_by_name, 'staff')">
                                    <img v-if="punishment.banned_by_uuid === null || punishment.banned_by_uuid === '49979a7a-01f5-4615-9cd1-358875a629a3'"
                                         src="../../assets/logo.png">
                                    <img v-else-if="punishment.banned_by_uuid !== null && punishment.banned_by_uuid !== 'CONSOLE'"
                                         :src="'https://visage.surgeplay.com/face/25/'+punishment.banned_by_uuid"/>
                                    <img v-else src="../../assets/console.png"/>
                                    <span v-if="punishment.banned_by_uuid !== null && punishment.banned_by_uuid === '49979a7a-01f5-4615-9cd1-358875a629a3'">FreakyVille</span>
                                    <span v-else>{{punishment.banned_by_name}}</span>
                                </router-link>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="hasPermission(['bansite.view.*', 'bansite.view.reason']) && type !== 'name'">
                        <td>Begrundelse</td>
                        <td>{{punishment.reason}}</td>
                    </tr>
                    <tr>
                        <td>{{titled}} den</td>
                        <td>{{this.$utils.parseDate(punishment.time)}}</td>
                    </tr>
                    <tr v-if="type !== 'kick' && type !== 'name'">
                        <td>Udløber</td>
                        <td>
                            {{$utils.parseUntilDate(punishment.until)}}
                            <div v-if="this.$utils.isExpired(punishment.removed_by_name, punishment.until) === 1"
                                 class="expired">(udløbet)
                            </div>
                            <div v-else-if="this.$utils.isExpired(punishment.removed_by_name, punishment.until) === 2"
                                 class="expired">(un{{titled.toLowerCase()}} af {{punishment.removed_by_name}})
                            </div>
                        </td>
                    </tr>
                    <tr v-if="type === 'name' && punishment.active === 0">
                        <td>Udløber</td>
                        <td>
                            <div>
                                class="expired">(unbanned af {{punishment.removed_by_name === 'FvForum' ?
                                'FreakyVille' :punishment.removed_by_name}})
                            </div>
                        </td>
                    </tr>
                    <tr v-if="hasPermission(['bansite.view.*', 'bansite.view.ipban']) && punishment.ipban !== undefined && punishment.ipban.data[0] === 1">
                        <td>IP {{title}}</td>
                        <td>{{punishment.ipban.data[0] === 0 ? "Nej" : "Ja"}}</td>
                    </tr>
                    <tr v-if="hasPermission(['bansite.view.*', 'bansite.view.ip']) && punishment.ip !== undefined && punishment.ip !== null && punishment.ip !== '#unknown'">
                        <td>IP</td>
                        <td @click="showIP = !showIP" style="cursor: pointer;">{{showIP ? punishment.ip : "Klik for at
                            se IPen"}}
                        </td>
                    </tr>
                    <tr v-if="hasPermission(['bansite.view.*', 'bansite.view.silent']) && punishment.silent !== undefined && punishment.silent.data[0] === 1">
                        <td>Skjult</td>
                        <td>{{punishment.silent.data[0] === 0 ? "Nej" : "Ja"}}</td>
                    </tr>
                    <tr v-if="hasPermission(['bansite.view.*', 'bansite.view.server']) && type !== 'name'">
                        <td>Server:</td>
                        <td>{{punishment.server_scope === '*' ? "Alle" : punishment.server_scope}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <LogTable :logs="logs" v-if="showLogInfo"></LogTable>
        <EditMcPunishmentModal
                :visible="showEditModal"
                :punishment="editPunishmentData"
                :kick="type === 'kick'"
                v-on:close="showEditModal = false"
                v-on:confirm="editPunishment($event)"/>
        <DeleteMcPunishmentModal
                :visible="showDeleteModal"
                v-on:close="showDeleteModal = false"
                v-on:confirm="unbanPunishment($event)"/>
    </div>
</template>

<script>
    import Progress from 'vue-top-progress'
    import EditMcPunishmentModal from '../../components/modals/EditMcPunishmentModal'
    import DeleteMcPunishmentModal from '../../components/modals/DeleteMcPunishmentModal'
    import LogTable from "../../components/tables/LogTable";

    export default {
        components: {
            LogTable,
            Progress,
            EditMcPunishmentModal,
            DeleteMcPunishmentModal
        },
        data() {
            return {
                punishment: {
                    name: null,
                    uuid: 'X-Steve',
                    banned_by_uuid: 'X-Steve'
                },
                showEditModal: false,
                showDeleteModal: false,
                showIP: false,
                logs: [],
                showLogInfo: false
            }
        },
        computed: {
            title() {
                let name = this.type;
                return name.substring(0, 1).toUpperCase() + name.substring(1);
            },
            titled() {
                switch (this.type) {
                    case "kick":
                        return "Kicked";
                    case "ban":
                        return "Banned";
                    case "mute":
                        return "Muted";
                    case "name":
                        return "Banned";
                    default:
                        return "Straffet";
                }
            },
            type() {
                return this.$utils.getPageType(this.$route.name).type;
            },
            editPunishmentData() {
                let date = new Date(this.punishment.until);
                return {
                    reason: this.punishment.reason,
                    expire: {
                        date: this.$utils.convertDateToInput(date),
                        time: this.$utils.convertTimeToInput(date)
                    },
                    permanent: this.punishment.until === -1,
                    silent: this.punishment.silent !== null && this.punishment.silent !== undefined ? this.punishment.silent.data[0] : null
                }
            },
            ownUuid() {
                return this.$api.getUser() !== null && this.$api.getUser().user !== null && this.$api.getUser().user.uuid ? this.$api.getUser().user.uuid : null;
            }
        },
        mounted() {
            this.updateData();
            if (this.$refs.topProgress !== undefined) {
                this.$refs.topProgress.start();
            }
            setTimeout(() => {
                this.showLogInfo = this.hasLogPermission();
            }, 1500);
        },
        methods: {
            hasLogPermission() {
                if (this.$api.getUser().user === null || this.$api.getUser().user === undefined) {
                    return false;
                } else if (this.$api.getUser().user.tags === null || this.$api.getUser().user.tags === undefined) {
                    return false;
                }
                let t = this.$api.getUser().user.tags.find(f => f.includes("bansite.log."));
                return this.$api.getUser().user.tags.includes("bansite.*") || (t !== null && t !== undefined);
            },
            editPunishment(data) {
                this.showEditModal = false;
                let type = this.$utils.getPageType(this.$route.name);
                this.$api.updatePunishment(type.category, type.type, this.$route.params.id, data).then(result => {
                    this.updateData();
                    this.$swal({
                        title: `${this.title} ændret!`,
                        text: `Det ${this.title.toLowerCase()} er blevet ændret korrekt!`,
                        icon: 'success',
                        toast: true,
                        position: "bottom",
                        timer: 5000,
                        timerProgressBar: true,
                    })
                })
            },
            unbanPunishment(data) {
                this.showDeleteModal = false;
                let type = this.$utils.getPageType(this.$route.name);
                let path = this.$route.fullPath
                this.$api.unbanPunishment(type.category, type.type, this.$route.params.id, data).then(result => {
                    if (result.deleted) {
                        this.$swal({
                            title: `${this.punishment.name} unbanned!`,
                            text: `${this.punishment.name} er blevet unbanned & bannet er slettet!`,
                            icon: 'success',
                            toast: true,
                            position: "bottom",
                            timer: 5000,
                            timerProgressBar: true,
                        }).then(ignored => {
                            if (this.$route.fullPath === path) {
                                this.$router.push({name: `${type.category}_${type.type}s`, params: {page: 1}});
                            }
                        });
                    } else {
                        this.updateData();
                        this.$swal({
                            title: `${this.punishment.name} unbanned!`,
                            text: `${this.punishment.name} er blevet unbanned!`,
                            icon: 'success',
                            toast: true,
                            position: "bottom",
                            timer: 5000,
                            timerProgressBar: true,
                        })
                    }
                })
            },
            updateData() {
                let type = this.$utils.getPageType(this.$route.name);
                this.$api.getPunishment(type.category, type.type + 's', this.$route.params.id).then(res => {
                    this.punishment = res;
                    if (type.type === 'name') {
                        this.punishment.uuid = 'X-Steve';
                    }
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.done()
                    }
                }).catch(err => {
                    console.log(err);
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.fail();
                    }
                });
                this.$api.getLogsOnEntry(type.category.toUpperCase() + '_' + type.type.toUpperCase(), this.$route.params.id).then(res => {
                    console.log(res);
                    this.logs = res;
                }).catch(err => {
                    console.log(err);
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.fail();
                    }
                });
            },
            hasPermission(perm) {
                return this.$api.getUser().hasPermission(perm);
            },
            getGoToUser(username, type) {
                return {name: 'mc_' + type, params: {username, page: 1}};
            }
        },
        watch: {
            '$route'(to, from) {
                this.updateData()
            }
        },
    }
</script>

<style lang="scss" scoped>
    .vm--overlay {
        background-color: rgba(0, 0, 0, .5) !important;
    }

    .vm--modal {
        background-color: #262A2F !important;
        box-shadow: 0 0 20px rgba(0, 0, 0, .3) !important;

        .dialog-c-title {
            font-size: 1.25rem;
        }
    }

    .info {
        width: 800px;
        margin: 0 auto;
        padding: 50px 0;

        .info-container {
            display: flex;
            justify-content: space-around;
        }

        .avatar {
            width: 178px;
            margin-right: 20px;
        }

        .table {
            width: calc(100% - 198px);

            table {
                width: 100%;
                margin-bottom: 1rem;

                thead {
                    background-color: #262a2d;

                    th {
                        vertical-align: middle;
                        overflow-wrap: break-word;
                        padding: .75rem;
                        font-weight: bold;
                        text-align: left;

                        .options {
                            float: right;

                            a {
                                color: #fff;
                                text-decoration: none;
                                margin: 0 5px;
                            }
                        }
                    }
                }

                tbody {
                    tr {
                        background-color: rgba(0, 0, 0, .05);

                        &:nth-of-type(odd) {
                            background-color: hsla(0, 0%, 100%, .05);
                        }

                        td {
                            vertical-align: middle;
                            overflow-wrap: break-word;
                            padding: .75rem;

                            .user-float a {
                                color: #fff;
                                display: flex;
                                align-items: center;
                                text-decoration: none;

                                img {
                                    border-radius: 2px;
                                    margin-right: 8px;
                                    width: 32px;
                                }
                            }

                            .expired {
                                padding-top: 5px;
                                font-style: italic;
                                font-size: 15px;
                                color: #878e94;
                                max-width: 100%;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1400px) {
    }

    @media screen and (max-width: 990px) {
        .info {
            width: auto;

            .avatar {
                display: none;
            }

            .table {
                width: 100%;
            }
        }
    }

    @media screen and (max-width: 760px) {
    }

    @media screen and (max-width: 585px) {
    }
</style>
